import IGrupoAlarme from "../interfaces/IGrupoAlarme";
import IPayload from "../interfaces/IPayload";
import { ToQueryString } from "../utils/utils";
import api from "./api";
import { resources } from "./resources";

class GrupoAlarmeService {
    async create(data: any) {
        return await api.post<IGrupoAlarme>(`${resources.grupoAlarme}/Create`, data);
    }

    async delete(id: any) {
        return await api.delete<any>(`${resources.grupoAlarme}/Delete/${id}`);
    }

    async getWithFilter(filters: any) {
        return await api.get<IPayload>(`${resources.grupoAlarme}/GetWithFilter/${ToQueryString(filters)}`);
    }

    async getAllTipoAlarme(filters: any) {
        return await api.get<any>(`${resources.grupoAlarme}/GetAllTipoAlarme/${ToQueryString(filters)}`);
    }
}

export default new GrupoAlarmeService();
